import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import {
  fetchedPlayer,
  getAccessibleBoards,
} from "../../features/player/playerSlice";

import { useAppSelector } from "../../store";
import {
  Typography,
  Box,
  Alert,
  Stack,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Zoom,
} from "@mui/material";

interface RegisterValidationProps {}

const RegisterValidation: FC<RegisterValidationProps> = () => {
  const player = useAppSelector(fetchedPlayer);
  const boards = useAppSelector(getAccessibleBoards);
  const navigate = useNavigate();

  const sortedParticipations = [...(player?.participation || [])].sort(
    (a, b) => {
      const boardA = boards.find((board) => board.id === a.tableauId);
      const boardB = boards.find((board) => board.id === b.tableauId);

      if (boardA && boardB) {
        return boardA.name.localeCompare(boardB.name); // Trie par le nom du tableau
      }
      return 0;
    }
  );

  return (
    <Zoom in>
      <Stack spacing={4} alignItems="center" maxWidth={800} mx="auto">
        <Alert severity="success" variant="standard">
          Votre inscription a réussi.
        </Alert>

        <Typography
          variant="h5"
          fontWeight={600}
          gutterBottom
          color="text.primary"
        >
          Vous êtes inscrit aux tableaux suivants :
        </Typography>

        <TableContainer
          component={Paper}
          variant="section"
          sx={{ width: "100%" }}
        >
          <Table aria-label="inscriptions">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell align="right">Nom</TableCell>
                <TableCell align="right">Jour</TableCell>
                <TableCell align="right">Fin pointage</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedParticipations?.map((participation) => {
                const board = boards.find(
                  (board) => board.id === participation.tableauId
                );

                return (
                  <TableRow key={board?.name}>
                    <TableCell>{board?.name}</TableCell>
                    <TableCell align="right">{board?.label}</TableCell>
                    <TableCell align="right">
                      {new Date(board?.date ?? "").toLocaleDateString("fr-FR", {
                        dateStyle: "full",
                      })}
                    </TableCell>
                    <TableCell align="right">{board?.heureLimite}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          width="100%"
          mt={4}
          p={2}
          borderRadius={2}
          boxShadow={2}
          bgcolor="background.paper"
        >
          <Button
            onClick={() => navigate("/register")}
            variant="contained"
            color="secondary"
            fullWidth
            sx={{
              transition: "transform 0.3s ease",
              "&:hover": { transform: "translateY(-2px)" },
            }}
            startIcon={<span style={{ fontSize: "1.2rem" }}>➕</span>}
          >
            Inscrire un autre joueur
          </Button>
        </Box>
      </Stack>
    </Zoom>
  );
};

export default RegisterValidation;
